export default __webpack_public_path__ + "static/media/GiftCardV2.0fd24cc7.svg";